/*
 * @Author: Teemo Ding
 * @Date: 2021-08-30 14:42:46
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-15 15:20:54
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelDiscounts/SubscriptionBuy/List/config.tsx
 */
// import { Tag, Image } from 'src/components/Antd';
import GlobalTooltip from '@/src/components/GlobalTooltip/GlobalTooltip';
import { Icon } from '@/src/tools/icon';
import React from 'react';
import { DropDown, Menu, MenuItem } from 'src/components/Antd';
import { EnumStatus } from 'src/types/common/discount';
import StatusTag from '../../Components/StatusTag';
// import { monent } from 'monent';
import { getI18nFromGeneral } from 'src/tools/tools';
import css from './css.module.less';
const switchToDraft = [
  EnumStatus.Active,
  EnumStatus.Scheduled,
  EnumStatus.Expired,
];

export enum StatusChange {
  Publish = 'Publish',
  Archive = 'Archive',
  Restore = 'Restore',
  ToDraft = 'ToDraft',
  Duplicate = 'Duplicate',
}

export enum ModalType {
  ArchiveDiscount = 'ArchiveDiscount',
  UnableToPublish = 'UnableToPublish',
}

const overlay = (data) => (
  <Menu className={css.overlay}>
    {data.map((item) => (
      <MenuItem
        className={`${css.menuItem} ${item.name.toLowerCase()}`}
        key={item.key}
        onClick={() => item.function()}>
        {item.name}
      </MenuItem>
    ))}
  </Menu>
);
export enum FrequencyUnit {
  Days = 'Days',
  Weeks = 'Weeks',
  Months = 'Months',
}
const frequencyUnitList = {
  [FrequencyUnit.Days]: getI18nFromGeneral('general.commonDate.day(s)'),
  [FrequencyUnit.Weeks]: getI18nFromGeneral('general.commonDate.week(s)'),
  [FrequencyUnit.Months]: getI18nFromGeneral('general.commonDate.month(s)'),
};

export const columns = (
  editFun,
  statusChange,
  statusChangeModal,
  tabsActive,
  disableEdit,
  disableDelete,
  { getI18n },
) => [
  {
    title: getI18n('salesChannelSubscriptionBuy.list.subscriptionBuyName'),
    dataIndex: 'name',
    key: 'name',
    default: true,
    className: css.columnClass,
    sorter: true,
    width: 240,
  },
  ...(tabsActive !== EnumStatus.Archived
    ? [
        {
          title: getI18n('general.status'),
          dataIndex: 'status',
          default: true,
          key: 'status',
          className: css.columnClass,
          minWidth: 200,
          ...(tabsActive === tabsConfig({ getI18n })[0].key
            ? { sorter: true }
            : {}),
          childGenerate: (text, record) => {
            return <StatusTag status={text} />;
          },
        },
      ]
    : []),
  {
    title: getI18n(
      'salesChannelSubscriptionBuy.frequency.subscriptionBuyFrequency',
    ),
    dataIndex: 'frequencies',
    default: true,
    key: 'frequencies',
    className: css.columnClass,
    minWidth: 200,
    childGenerate: (text, record) => {
      const textAll = text.map(
        (item, index) =>
          `Every ${item.frequency} ${frequencyUnitList[item.frequencyUnit]}${
            index < (text || []).length - 1 ? ', ' : ''
          }`,
      );
      return (
        <GlobalTooltip title={textAll}>
          <div className={css.codes}>{textAll}</div>
        </GlobalTooltip>
      );
    },
  },

  {
    title: getI18n(
      'general.advancedFilters.commonStoreProductsWithTable.actions',
    ),
    dataIndex: 'actions',
    default: true,
    key: 'actions',
    className: css.columnClass,
    minWidth: 128,
    align: 'center',
    childGenerate: (text, record) => {
      const overlayActionNoDraftList = overlayActionNoDraft(
        record.status,
        record.uuid,
        editFun,
        statusChange,
        record.canPublish,
        statusChangeModal,
        disableEdit,
        disableDelete,
        { getI18n },
      );
      return (
        <DropDown
          overlay={overlay(overlayActionNoDraftList)}
          getPopupContainer={() => document.body}
          placement='bottomRight'
          trigger={['click']}>
          <div className={css.moreActions}>
            <Icon type='iconMore'></Icon>
          </div>
        </DropDown>
      );
    },
  },
];

const overlayActionNoDraft = (
  type,
  uuid,
  editFun,
  statusChange,
  canPublish,
  statusChangeModal,
  disableEdit,
  disableDelete,
  { getI18n },
) => [
  {
    name: getI18n('general.edit'),
    key: 1,
    function: () => editFun(uuid, false),
  },
  // ...(type !== EnumStatus.Archived
  //   ? [
  //       {
  //         name: 'Duplicate',
  //         key: 2,
  //         function: () => statusChange([uuid], StatusChange.Duplicate),
  //         disabled: disableEdit,
  //       },
  //     ]
  //   : []),

  ...(type == EnumStatus.Draft && !disableEdit
    ? [
        {
          name: getI18n('general.publish'),
          key: 3,
          function: () =>
            statusChange([uuid], StatusChange.Publish, canPublish),
          disabled: disableEdit,
        },
      ]
    : []),
  ...(switchToDraft.includes(type) && !disableEdit
    ? [
        {
          name: getI18n('general.switchToDraft'),
          key: 4,
          function: () => statusChange([uuid], StatusChange.ToDraft),
          disabled: disableEdit,
        },
      ]
    : []),
  ,
  ...(type !== EnumStatus.Archived && !disableDelete
    ? [
        {
          name: getI18n('general.archive'),
          key: 5,
          function: () => statusChangeModal([uuid], ModalType.ArchiveDiscount),
          disabled: disableDelete,
        },
      ]
    : []),
  ...(type == EnumStatus.Archived && !disableEdit
    ? [
        {
          name: getI18n('general.restore'),
          key: 6,
          function: () => statusChange([uuid], StatusChange.ToDraft),
          disabled: disableEdit,
        },
      ]
    : []),
];

export const breadcrumbData = (
  salesChannelUuid,
  salesChannelName,
  { getI18n },
) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/salesChannels',
    name: getI18n('general.sider.salesChannel'),
  },
  {
    url: `/${salesChannelUuid}`,
    name: salesChannelName,
  },
  {
    url: '',
    name: getI18n('salesChannelDirectDiscount.list.discount'),
  },
  {
    url: '',
    name: getI18n('general.subscriptionBuy'),
  },
];

export const tabsConfig = ({ getI18n }) => {
  const i18n = getI18n
    ? getI18n
    : () => {
        return;
      };
  return [
    //定义tabs列表
    { name: i18n('general.all'), key: '' },
    { name: i18n('general.status.draft'), key: EnumStatus.Draft },
    { name: i18n('general.status.active'), key: EnumStatus.Active },
    { name: i18n('general.archive'), key: EnumStatus.Archived },
  ];
};
